import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import FixedCallBar from './components/FixedCallBar';
import ScrollManager from './components/ScrollManager';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import RefundPolicy from './pages/RefundPolicy';
import Disclaimer from './pages/Disclaimer';
import NotFound from './pages/NotFound';
import { BRAND, SITE_NAME } from './constants/site';

const PAGE_TITLES = {
  '/': `${SITE_NAME} — ${BRAND} Antivirus, VPN & Identity Security`,
  '/contact': `Contact Support | ${SITE_NAME}`,
  '/privacy-policy': `Privacy Policy | ${SITE_NAME}`,
  '/terms-of-service': `Terms of Service | ${SITE_NAME}`,
  '/refund-policy': `Refund Policy | ${SITE_NAME}`,
  '/disclaimer': `Disclaimer | ${SITE_NAME}`,
};

function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = PAGE_TITLES[pathname] || `Page Not Found | ${SITE_NAME}`;
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <DocumentTitle />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <FixedCallBar />
    </BrowserRouter>
  );
}
